import React from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import ENUMS from '../../enums/index';
import * as discountCodesActions from '../../redux/discountCodes/actions';
import Spin from '../../components/loading';
import ShowForPermission from '../../components/ShowForPermission';
import { enumHelper } from '../../utils';
import { numberWithCommas } from '../../utils/formatter';
import generateClassName from '../../utils/generateClassName';
import AlertAndConfirmation from '../../utils/AlertAndConfirmation';

class DiscountCodesTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      discountCodeOpen: false,
      selectedDiscountCodeId: null,
      status: '',
      isActive: false,
      sortedColumn: '',
    };
  }

  renderStatusColors = status => {
    switch (status) {
      case 'ACTIVE':
        return 'text-success';
      case 'INACTIVE':
        return 'text-danger';
      default:
        return 'text-info';
    }
  };

  updateDiscountCodeStatus = discountCode => {
    this.props
      .updateDiscountCodeStatus(
        discountCode.id,
        discountCode.status == ENUMS.DISCOUNT_CODES_STATUS.values.ACTIVE
          ? ENUMS.DISCOUNT_CODES_STATUS.values.INACTIVE
          : ENUMS.DISCOUNT_CODES_STATUS.values.ACTIVE,
      )
      .then(() => {
        let {
          updateDiscountCodeStatusError,
          updateDiscountCodeStatusFailed,
          updateDiscountCodeStatusMessage,
        } = this.props;
        if (
          updateDiscountCodeStatusFailed == false &&
          updateDiscountCodeStatusError == false &&
          updateDiscountCodeStatusMessage == null
        ) {
          AlertAndConfirmation({
            title: locales('titles.editionsDoneSuccessfully'),
            text: '',
            type: 'success',
          });
          const query = this.props.buildSearchQuery(this.props.pageNumber, this.props.pageSize);
          this.props.fetchAllDiscountCodes(query);
        }
      });
  };

  sortTable = query => {
    this.props.sortTable(query);
    this.setState({ sortedColumn: query });
  };

  render() {
    let {
      discountCodesList = [],
      pageNumber,
      pageSize,
      sortType,

      discountCodesLoading,
      discountCodesMessage,
      discountCodesError,
      discountCodesFailed,

      updateDiscountCodeStatusLoading,
      updateDiscountCodeStatusFailed,
      updateDiscountCodeStatusError,
      updateDiscountCodeStatusMessage,
    } = this.props;
    return (
      <>
        <Spin spinning={discountCodesLoading || updateDiscountCodeStatusLoading}>
          {(discountCodesError || updateDiscountCodeStatusError) && (
            <div className="alert alert-danger">{locales('messages.server.error')}</div>
          )}
          {(discountCodesFailed || updateDiscountCodeStatusFailed) && (
            <div className="alert alert-danger">
              {discountCodesMessage || updateDiscountCodeStatusMessage}
            </div>
          )}
          <table className="table table-hover table-light table-striped">
            <thead>
              <tr>
                <th className="text-center">{locales('tables.row')}</th>
                <th onClick={() => this.sortTable('title')} className="text-center pointer">
                  <i name="title" className={generateClassName('title', this.state.sortedColumn, sortType)} />
                  {locales('tables.title')}
                </th>
                <th onClick={() => this.sortTable('code')} className="text-center pointer">
                  <i name="code" className={generateClassName('code', this.state.sortedColumn, sortType)} />
                  {locales('tables.code')}
                </th>
                <th onClick={() => this.sortTable('status')} className="text-center pointer">
                  <i
                    name="status"
                    className={generateClassName('status', this.state.sortedColumn, sortType)}
                  />
                  {locales('tables.status')}
                </th>
                <th onClick={() => this.sortTable('includedUsersCount')} className="text-center pointer">
                  <i
                    name="includedUsersCount"
                    className={generateClassName('includedUsersCount', this.state.sortedColumn, sortType)}
                  />
                  {locales('tables.includedUsersCount')}
                </th>
                <th onClick={() => this.sortTable('usedCount')} className="text-center pointer">
                  <i
                    name="usedCount"
                    className={generateClassName('usedCount', this.state.sortedColumn, sortType)}
                  />
                  {locales('tables.usedCount')}
                </th>
                <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_CAFE_DATES_LIST_FOR_ADMIN}>
                  <th className="text-center pointer">
                    <i
                      name="cafeName"
                      className={generateClassName('discountType', this.state.sortedColumn, sortType)}
                    />
                    {locales('fields.cafe.name')}
                  </th>
                </ShowForPermission>
                <th onClick={() => this.sortTable('discountType')} className="text-center pointer">
                  <i
                    name="discountType"
                    className={generateClassName('discountType', this.state.sortedColumn, sortType)}
                  />
                  {locales('tables.discountType')}
                </th>
                <th onClick={() => this.sortTable('discountValue')} className="text-center pointer">
                  <i
                    name="discountValue"
                    className={generateClassName('discountValue', this.state.sortedColumn, sortType)}
                  />
                  {locales('tables.discountValue')}
                </th>
                <th onClick={() => this.sortTable('expiredAtJalaali')} className="text-center pointer">
                  <i
                    name="expiredAtJalaali"
                    className={generateClassName('expiredAtJalaali', this.state.sortedColumn, sortType)}
                  />
                  {locales('tables.expiredAtJalaali')}
                </th>
                <th className="text-center"></th>
                <th className="text-center"></th>
                <th className="text-center"></th>
                <th className="text-center"></th>
              </tr>
            </thead>
            <tbody>
              {discountCodesList.length ? (
                discountCodesList.map((discountCode, index) => (
                  <tr key={discountCode.id}>
                    <td className="text-center">{(pageNumber - 1) * pageSize + index + 1}</td>
                    <td className="text-center">{discountCode.title}</td>
                    <td className="text-center">{discountCode.code}</td>
                    <td className={`text-center ${this.renderStatusColors(discountCode.status)}`}>
                      {enumHelper.convertEnumValueToTitle(
                        ENUMS.DISCOUNT_CODES_STATUS.list,
                        discountCode.status,
                      )}
                    </td>
                    <td className={`text-center`}>{discountCode.countUsable}</td>
                    <td className={`text-center`}>{discountCode.countUsed}</td>
                    <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_CAFE_DATES_LIST_FOR_ADMIN}>
                      {discountCode.cafeName !== null ?
                        <td>{discountCode.cafeName}</td>
                        : <td>--</td>}
                    </ShowForPermission>
                    <td className={`text-center`}>
                      {enumHelper.convertEnumValueToTitle(ENUMS.DISCOUNT_CODES_TYPES.list, discountCode.type)}
                    </td>
                    <td className="text-center">
                      {discountCode.type === ENUMS.DISCOUNT_CODES_TYPES.values.VALUE
                        ? numberWithCommas(discountCode.amount)
                        : discountCode.amount}
                    </td>
                    <td className="text-center">{discountCode.validTo}</td>
                    <td title={locales('titles.editDiscountCode')}>
                      <ShowForPermission permission={ENUMS.PERMISSIONS.values.EDIT_STATUS_DISCOUNT_CODE}>
                        <button
                          onClick={() => this.updateDiscountCodeStatus(discountCode)}
                          className={`btn btn-sm ${discountCode.status == ENUMS.DISCOUNT_CODES_STATUS.values.ACTIVE
                            ? 'btn-danger'
                            : 'btn-success'
                            }`}
                        >
                          {discountCode.status == ENUMS.DISCOUNT_CODES_STATUS.values.ACTIVE
                            ? locales('tables.deactivate')
                            : locales('tables.activate')}
                        </button>
                      </ShowForPermission>
                    </td>
                    <td title={locales('titles.editDiscountCode')}>
                      <ShowForPermission permission={ENUMS.PERMISSIONS.values.EDIT_DISCOUNT_CODE}>
                        <NavLink
                          to={{
                            pathname: '/discount-codes/add-or-edit',
                            discountCodeId: discountCode.id,
                            editMode: true,
                          }}
                        >
                          <i className="text-center fa fa-pencil text-secondary pointer" />
                        </NavLink>
                      </ShowForPermission>
                    </td>
                    <td title={locales('titles.discountCodeUsersList')}>
                      <NavLink
                        to={{
                          pathname: '/discount-codes/users',
                          title: discountCode.title,
                          validTo: discountCode.validTo,
                          validFrom: discountCode.validFrom,
                          discountCodeId: discountCode.id,
                        }}
                      >
                        <i className="text-center fal fa-users-class text-success pointer" />
                      </NavLink>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="col-12 text-center">
                  <td className="alert alert-info" colSpan={12}>
                    {locales('alerts.noRecord')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    discountCodesList: state.discountCodesReducer.discountCodesList,
    discountCodes: state.discountCodesReducer.discountCodes,
    discountCodesFailed: state.discountCodesReducer.discountCodesFailed,
    discountCodesError: state.discountCodesReducer.discountCodesError,
    discountCodesMessage: state.discountCodesReducer.discountCodesMessage,
    discountCodesLoading: state.discountCodesReducer.discountCodesLoading,

    updateDiscountCodeStatusLoading: state.discountCodesReducer.updateDiscountCodeStatusLoading,
    updateDiscountCodeStatusError: state.discountCodesReducer.updateDiscountCodeStatusError,
    updateDiscountCodeStatusFailed: state.discountCodesReducer.updateDiscountCodeStatusFailed,
    updateDiscountCodeStatusMessage: state.discountCodesReducer.updateDiscountCodeStatusMessage,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllDiscountCodes: query => dispatch(discountCodesActions.fetchAllDiscountCodes(query)),
    updateDiscountCodeStatus: (id, status) =>
      dispatch(discountCodesActions.updateDiscountCodeStatus(id, status)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(DiscountCodesTable),
);
